export default __webpack_public_path__ + "static/media/deviants_gallery_preview.b0297732.jpg";